import { render, staticRenderFns } from "./lista-v2.vue?vue&type=template&id=fd55cada&scoped=true"
import script from "./lista-v2.vue?vue&type=script&lang=js"
export * from "./lista-v2.vue?vue&type=script&lang=js"
import style0 from "./lista-v2.vue?vue&type=style&index=0&id=fd55cada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd55cada",
  null
  
)

export default component.exports